import React from "react";
import { useState } from "react";
import "./styles.css";
import { Flex,Tooltip,message } from "antd";
import { CopyOutlined } from '@ant-design/icons';
import dayjs from "dayjs";

const MeetingInformationPopup = ({ meetingData, invitees }) => {

  const [copied, setCopied] = useState(false);

  
  const copyToClipboard = () => {
    navigator.clipboard.writeText(meetingData.meetingRoomLink).then(() => {
      message.success('Link copied to clipboard');
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div
      id="calendar-popup"
      className="popupDiv"
      style={{ height: "63vh", overflow: "auto" }}
    >
      {meetingData.empCode !== meetingData.createdBy && (
        <div className="not-created">*You did not create this meeting</div>
      )}
      <Flex vertical>
        <div className="meeting-title-heading">{meetingData.meetingRoomName !== 'Virtual Meeting' ?'Meeting Room' : 'Meeting Mode'}</div>
        <div className="meeting-title">{meetingData.meetingRoomName}</div>
      </Flex>
      <Flex vertical>
        <div className="meeting-title-heading">Subject</div>
        <div className="meeting-title">{meetingData.title}</div>
      </Flex>
      {meetingData.agenda && (
        <Flex vertical>
          <div className="meeting-title-heading">Agenda</div>
          <div
            className="meeting-title"
            dangerouslySetInnerHTML={{ __html: meetingData.agenda }}
          />
        </Flex>
      )}
      {meetingData.meetingRoomLink && (
        <Flex vertical>
          <div className="meeting-title-heading">Link</div>
            {meetingData.meetingRoomName === 'Virtual Meeting' ? (
       <div className="virtual-meeting-container">

        <a
          href={meetingData.meetingRoomLink}
          target="_blank"
          rel="noopener noreferrer"
          className="virtual-meeting-link"
        >
          Join Meeting
        </a>

        <Tooltip title="Copy link">
        <CopyOutlined
          onClick={copyToClipboard}
          style={{ cursor: 'pointer', fontSize: '16px', color: '#1890ff' }}
        />
        </Tooltip>
        </div>

 
        
      ) : (
        <div className="meeting-title">      

          { meetingData.meetingRoomLink}
        </div>
      )}
      
        </Flex>
      )}
      
      {/* <Flex gap={"0.8rem"} justify="center">
        <Flex gap="0.5rem">
          <div className="meeting-title-heading meeting-time">Starts at </div>
          <div className="meeting-title">
            {dayjs(meetingData.start).format("h:mm A")}
          </div>
        </Flex>
        <Flex gap="0.5rem">
          <div className="meeting-title-heading meeting-time">Ends at </div>
          <div className="meeting-title">
            {dayjs(meetingData.end).format("h:mm A")}
          </div>
        </Flex>
      </Flex> */}

    <div className="meeting-time-wrapper">
      <div className="meeting-time-box">
        <label className="meeting-title-heading meeting-time">Start Time</label>
        <div className="meeting-time-input">
          {dayjs(meetingData.start).format("HH:mm")}
        </div>
      </div>
      <div className="meeting-time-box">
        <label className="meeting-title-heading meeting-time">End Time</label>
        <div className="meeting-time-input">
          {dayjs(meetingData.end).format("HH:mm")}
        </div>
      </div>
    </div>

      

      <Flex vertical>
        <p className="meeting-title-heading">Invitees</p>
        <Flex gap={"0.5rem"}>
          <ul>
            {invitees.map((invitee, ind) => (
              <li className="invitees-label">{invitee.label}</li>
            ))}
          </ul>
        </Flex>
      </Flex>
    </div>
  );
};

export default MeetingInformationPopup;
